import { render, staticRenderFns } from "./Danmaku.vue?vue&type=template&id=53d591d3&scoped=true"
import script from "./Danmaku.vue?vue&type=script&lang=js"
export * from "./Danmaku.vue?vue&type=script&lang=js"
import style0 from "./Danmaku.vue?vue&type=style&index=0&id=53d591d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d591d3",
  null
  
)

export default component.exports